import { Injectable } from '@angular/core';
import { InvoiceService } from '../services/invoice.service';
import { AuthenticationInfoService } from './authentication-info.service';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, filter, map, mergeMap, of } from 'rxjs';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class InvoiceGuard  {

    constructor(
        private invoiceService: InvoiceService,
        private authenticationInfoService: AuthenticationInfoService,
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const id = route.params.id;

        const profileLoaded$ = this.authenticationInfoService.userProfileLoaded$.pipe(
            filter(userProfile => !_.isNil(userProfile)));
        return profileLoaded$.pipe(mergeMap(_ => this.invoiceService.canView(id)
            .pipe(map(_ => {
                return true;
            }),
                catchError(_ => {
                    return of(false);
                }))));
    }
}